import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';
import { Icon } from '@trg/tlw-ui-component';

export type ClearProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
>;

export function Clear({ className, ...props }: ClearProps) {
  return (
    <button
      className={clsx(
        'tlw-p-1 tlw-text-txt-700/50 hover:tlw-text-txt-700 active:tlw-text-txt-700',
        className
      )}
      {...props}
    >
      <Icon name="Delete" size={16} />
    </button>
  );
}
